import { Box, Skeleton } from '@mui/material';
import { AboutYouBox } from './about-you-box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoadingAboutYou = function LoadingAboutYou() {
  return /*#__PURE__*/_jsxs(AboutYouBox, {
    "data-element": "AboutYouBox",
    "data-component": "LoadingAboutYou",
    "data-source-file": "loading.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        mb: 2
      },
      "data-element": "Box",
      "data-component": "LoadingAboutYou",
      "data-source-file": "loading.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        variant: "circular",
        width: 128,
        height: 128,
        "data-element": "Skeleton",
        "data-component": "LoadingAboutYou",
        "data-source-file": "loading.tsx"
      }), /*#__PURE__*/_jsxs(Box, {
        "data-element": "Box",
        "data-source-file": "loading.tsx",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          sx: {
            ml: 2
          },
          width: 120,
          height: 40,
          "data-element": "Skeleton",
          "data-source-file": "loading.tsx"
        }), /*#__PURE__*/_jsx(Skeleton, {
          sx: {
            ml: 2
          },
          width: 120,
          height: 40,
          "data-element": "Skeleton",
          "data-source-file": "loading.tsx"
        })]
      })]
    }), /*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: 80,
      "data-element": "Skeleton",
      "data-source-file": "loading.tsx"
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      },
      "data-element": "Box",
      "data-source-file": "loading.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        sx: {
          mr: 3,
          width: 1
        },
        height: 80,
        "data-element": "Skeleton",
        "data-source-file": "loading.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        sx: {
          width: 1
        },
        height: 80,
        "data-element": "Skeleton",
        "data-source-file": "loading.tsx"
      })]
    }), /*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: 80,
      "data-element": "Skeleton",
      "data-source-file": "loading.tsx"
    }), /*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: 80,
      "data-element": "Skeleton",
      "data-source-file": "loading.tsx"
    })]
  });
};

export default LoadingAboutYou;